module.exports = "<ul id=\"wd-{{id}}\" class=\"wd-tree\">\n</ul>";